import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login'
import Invoices from '../views/Invoices'
import Budgets from '../views/Budgets'
import Budget from '../views/Budget'
import Clients from '../views/Clients'
import Client from '../views/Client'
import contable from "../views/contable";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices
  },
  {
    path: '/budgets',
    name: 'Budgets',
    component: Budgets
  },
  {
    path: '/budget/:id',
    name: 'Budget',
    component: Budget
  },
  {
    path: '/clients',
    name: 'Clients',
    component: Clients
  },
  {
    path: '/clientdata/:id',
    name: 'Client',
    component: Client
  },
  {
    path: '/contable',
    name: 'Contable',
    component: contable
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
